import { functions } from 'config/firebase'

export { default as sendTermsEmail } from './termsEmail'
export { default as sendDownloadEmail } from './downloadAppEmail'

export const sendEmailReq = functions.httpsCallable('sendEmail')

const sendEmail = (
  to: string,
  subject: string,
  body: string,
  text: string = ''
) => {
  sendEmailReq({
    to,
    subject,
    body,
    text,
    APP_NAME: process.env.REACT_APP_APP_NAME,
    clientID: process.env.REACT_APP_CLIENT_ID,
    clientSecret: process.env.REACT_APP_CLIENT_SECRET,
    refreshToken: process.env.REACT_APP_REFRESH_TOKEN,
    redirectUrl: process.env.REACT_APP_REDIRECT_URL
  })
}

export default sendEmail



// WEBPACK FOOTER //
// ./src/services/email/index.ts